import React, { useState, useEffect } from 'react';
import { Spinner } from '@fluentui/react';
import useAxios from 'axios-hooks';
import { useRouteMatch, useHistory } from 'react-router-dom';
import WebinarsTable from '../Components/WebinarsTable';
import DeleteModal from "../../../Util/DeleteModal";
import { useBoolean } from '@fluentui/react-hooks';
import ErrorComponent from '../../../Util/ErrorComponent';
import SuccessComponent from '../../../Util/SuccessComponent';

const DefaultPage = () => {
    const [selectedWebinar, setSelectedWebinar] = useState(undefined);
    const history = useHistory();
    const [showSuccess, setShowSuccess] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    let { url } = useRouteMatch();
    const [showDeleteModal, { toggle: toggleDeleteModal }] = useBoolean(false);

    const [{ data: webinars, loading }, refetch] = useAxios("webinars/all");

    if (loading) return <Spinner className="absolute-center" label="Loading webinars..." />;

    return (
        <>
            <SuccessComponent
                successMessage="Webinar Deleted."
                showSuccess={showSuccess}
                setShowSuccess={setShowSuccess}
            />
            <ErrorComponent
                errorMessage={errorMsg}
                showError={showError}
                setShowError={setShowError}
            />
            <WebinarsTable
                webinars={webinars && webinars.length > 0 ? webinars.sort((a, b) => b.webinarId - a.webinarId) : []}
                setSelectedWebinar={setSelectedWebinar}
                selectedWebinar={selectedWebinar}
                createOnClick={() => history.push(`${url}/wizard`)}
                editOnClick={(id) => history.push(`${url}/${id}/wizard`)}
                deleteOnClick={() => toggleDeleteModal()}
                refetch={refetch}
                loading={loading}
            />
            <DeleteModal
                showModal={showDeleteModal}
                toggleShowModal={toggleDeleteModal}
                onDelete={() => refetch()}
                setErrorMsg={setErrorMsg}
                setShowError={setShowError}
                setShowSuccess={setShowSuccess}
                deleteUrl={`webinars/delete/${selectedWebinar}/`}
                resourceType="webinar"
            />
        </>
    );
};

export default DefaultPage;
